import React from 'react';

function Trivia({ post }) {
	return (
		<div>{post.data.name}</div>
	)
}

export default Trivia